// import _ from "lodash"
import find from 'lodash/find';
import orderBy from 'lodash/orderBy';
import rulesHandler from "@/services/rulesHandler";

async function refactorTree(tree, rules, rulesSchema, lang) {

    var treePrematch = [];
    var treeAntepost = [];
    var hybridSports = [8767920470, 7993760639, 7242184727, 2041853960, 6234271262];

    await Promise.all(tree.map(async (sport) => {

            var categoriesChildren = [];
            var categoriesChildrenAntepost = [];

            sport.status_rule = true

            if (rulesSchema.sportManager) {
                sport = await rulesHandler.applyRules(sport, rules.manager, sport._id)
            }

            if (rulesSchema.sportSkin) {
                sport = await rulesHandler.applyRules(sport, rules.skin, sport._id)
            }

            if (!sport.status_rule) {
                return
            }

            var desc_sport = await rulesHandler.getDesc(sport, lang)

            await Promise.all(sport.sport_categories.map(async (category) => {

                    category.status_rule = true

                    if (rulesSchema.categoryManager) {
                        category = await rulesHandler.applyRules(category, rules.manager, category.id)
                    }

                    if (rulesSchema.categorySkin) {
                        category = await rulesHandler.applyRules(category, rules.skin, category.id)
                    }

                    if (!category.status_rule) {
                        return
                    }

                    var desc_category = await rulesHandler.getDesc(category, lang)
                    var tournamentsChildren = [];
                    var tournamentsChildrenAntepost = [];

                    await Promise.all(category.categories_tournaments.map(async (tournament) => {

                            if (tournament.count_events > 0 || tournament.count_events_antepost > 0) {
                                tournament.status_rule = true

                                if (rulesSchema.tournamentManager) {
                                    tournament = await rulesHandler.applyRules(tournament, rules.manager, tournament.id)
                                }

                                if (rulesSchema.tournamentSkin) {
                                    tournament = await rulesHandler.applyRules(tournament, rules.skin, tournament.id)
                                }

                                if (!tournament.status_rule) {
                                    return
                                }

                                var desc_tournament = await rulesHandler.getDesc(tournament, lang)

                                if (tournament.count_events > 0) {

                                    const treeItemTournament = {
                                        id: tournament.id + '#prematch',
                                        icon_id: tournament.id,
                                        type: 'tournament',
                                        name: desc_tournament,
                                        count: tournament.count_events,
                                        typeOdds: 'prematch',
                                        order: (tournament.order) ? tournament.order : 9999,
                                        sportId: sport._id
                                    }

                                    tournamentsChildren.push(treeItemTournament);

                                }

                                if (tournament.count_events_antepost > 0) {

                                    var eventsAntepostChildren = []

                                    await Promise.all(tournament.detail_events_antepost.map(async (event) => {

                                            var status = true

                                            if (rulesSchema.eventManager || rulesSchema.eventSkin) {

                                                var rule_manager = await find(rules.manager, (rule) => {
                                                    return rule.type == "disable" && rule.scope == "event" && rule.source == event.id
                                                })

                                                var rule_skin = await find(rules.skin, (rule) => {
                                                    return rule.type == "disable" && rule.scope == "event" && rule.source == event.id
                                                })

                                                if (rule_manager != undefined) {
                                                    let rule = await find(rule_manager.detail, {'scope': 'event'})
                                                    if (rule) {
                                                        status = !rule.status
                                                    }
                                                }

                                                if (rule_skin != undefined) {
                                                    let rule = await find(rule_skin.detail, {'scope': 'event'})
                                                    if (rule) {
                                                        status = !rule.status
                                                    }
                                                }

                                            }

                                            if (status) {
                                                await getAntepostDetails(event, lang).then((event_refactor) => {
                                                    eventsAntepostChildren.push(event_refactor)
                                                })
                                            }
                                        })
                                    )

                                    const treeItemTournamentAntepost = {
                                        id: tournament.id + '#antepost',
                                        icon_id: tournament.id,
                                        type: 'tournament',
                                        name: desc_tournament,
                                        children: [
                                            ...eventsAntepostChildren
                                        ],
                                        count: tournament.count_events_antepost,
                                        typeOdds: 'antepost',
                                        order: (tournament.order) ? tournament.order : 9999
                                    }

                                    tournamentsChildrenAntepost.push(treeItemTournamentAntepost);

                                }
                            }
                        })
                    )

                    var tournaments_pm_ordered = orderBy(tournamentsChildren, ['order', 'name'])
                    var tournaments_ap_ordered = orderBy(tournamentsChildrenAntepost, ['order', 'name'])

                    if (category.count_events > 0) {
                        const treeItemCategory = {
                            id: category.id + '#prematch',
                            icon_id: category.id,
                            type: 'category',
                            name: desc_category,
                            children: [
                                ...tournaments_pm_ordered
                            ],
                            count: category.count_events,
                            typeOdds: 'prematch',
                            order: (category.order) ? category.order : 9999
                        }

                        categoriesChildren.push(treeItemCategory);
                    }

                    if (category.count_events_antepost > 0) {
                        const treeItemCategoryAntepost = {
                            id: category.id + '#antepost',
                            icon_id: category.id,
                            type: 'category',
                            name: desc_category,
                            children: [
                                ...tournaments_ap_ordered
                            ],
                            count: category.count_events_antepost,
                            typeOdds: 'antepost',
                            order: (category.order) ? category.order : 9999
                        }

                        categoriesChildrenAntepost.push(treeItemCategoryAntepost);
                    }
                })
            )

            var categories_pm_ordered = orderBy(categoriesChildren, ['order', 'name'])
            var categories_ap_ordered = orderBy(categoriesChildrenAntepost, ['order', 'name'])

            if (sport.count_events > 0) {
                const treeItem = {
                    id: sport._id + '#prematch',
                    icon_id: sport._id,
                    type: 'sport',
                    name: desc_sport,
                    children: [
                        ...categories_pm_ordered
                    ],
                    count: sport.count_events,
                    typeOdds: 'prematch',
                    order: (sport.order) ? sport.order : 9999
                }

                treePrematch.push(treeItem);
            }

            if (sport.count_events_antepost > 0) {
                const treeItemAntepost = {
                    id: sport._id + '#antepost',
                    icon_id: sport._id,
                    type: 'sport',
                    name: 'Antepost ' + desc_sport,
                    children: [
                        ...categories_ap_ordered
                    ],
                    count: sport.count_events_antepost,
                    typeOdds: 'antepost',
                    order: (sport.order) ? sport.order : 9999
                }


                if (hybridSports.includes(sport._id)) {

                    // Override Sport definiti come antepost, ma spostati nella parte dell'albero prematch
                    treeItemAntepost.name = desc_sport
                    treePrematch.push(treeItemAntepost);

                } else {

                    treeAntepost.push(treeItemAntepost);
                }


            }

        })
    )
    var tree_pm_ordered = orderBy(treePrematch, ['order', 'count', 'name'], ['asc', 'desc', 'asc'])
    var tree_ap_ordered = orderBy(treeAntepost, ['order', 'count', 'name'], ['asc', 'desc', 'asc'])
    return [
        ...tree_pm_ordered,
        {
            id: 9999 + '#antepost',
            icon_id: 9999,
            type: 'antepost_root',
            name: 'Antepost',
            children: [
                ...tree_ap_ordered
            ],
            count: 0,
            typeOdds: 'antepost',
            order: 9999
        },
    ]


}


async function getAntepostDetails(event, lang) {

    var desc_event = '';
    var fallbackDesc_event = '';

    var raceTitle = ''
    var raceNumber = ''
    desc_event = find(event.detail, {'lang': lang});
    if (!desc_event) {
        fallbackDesc_event = find(event.detail, {'lang': 'en'})
    }

    var name_event = (desc_event) ? desc_event.text : fallbackDesc_event.text

    if (event.FixtureExtraData) {
        raceTitle = find(event.FixtureExtraData, {'Name': 'RaceTitle'})
        if (raceTitle) {
            name_event += ' - ' + raceTitle.Value
        }

        raceNumber = find(event.FixtureExtraData, {'Name': 'RaceNumber'})

        if (raceNumber && raceTitle && !_.isUndefined(raceTitle.Value) && !raceTitle.Value.toString().includes(raceNumber.Value.toString())) {
            name_event += ' - n°' + raceNumber.Value
        }

    }

    return {
        id: event.id + '#antepost',
        name: name_event,
        type: 'antepost'
    }

}


async function refactorSports(sports, rules, rulesSchema, language) {

    const arrayOfSportsToSave = [];

    await Promise.all(sports.map(async (sport) => {

            sport.status_rule = true

            if (rulesSchema.sportManager) {
                sport = await rulesHandler.applyRules(sport, rules.manager, sport.sportId)
            }

            if (rulesSchema.sportSkin) {
                sport = await rulesHandler.applyRules(sport, rules.skin, sport.sportId)
            }

            if (!sport.status_rule) {
                // console.log('EXCLUDING SPORT WITH ID: ' + sport.sportId)
                return
            }

            await rulesHandler.applyTranslationToElement(sport, language)

            arrayOfSportsToSave.push(sport);
        }
    ))

    const tree_pm_ordered = orderBy(arrayOfSportsToSave, ['order', 'count', 'name'], ['asc', 'desc', 'asc'])
    return tree_pm_ordered
}


async function refactorCategories(categories, rules, rulesSchema, language) {

    const arrayOfCategoriesToSave = [];

    await Promise.all(categories.map(async (category) => {

            category.status_rule = true

            if (rulesSchema.categoryManager) {
                category = await rulesHandler.applyRules(category, rules.manager, category.categoryId)
            }

            if (rulesSchema.categorySkin) {
                category = await rulesHandler.applyRules(category, rules.skin, category.categoryId)
            }

            if (!category.status_rule) {
                // console.log('EXCLUDING CATEGORY WITH ID: ' + category.categoryId)
                return
            }
            await rulesHandler.applyTranslationToElement(category, language)


            arrayOfCategoriesToSave.push(category);
        }
    ))

    const categories_pm_ordered = orderBy(arrayOfCategoriesToSave, ['order', 'name'])

    return categories_pm_ordered
}

async function refactorTournaments(tournaments, rules, rulesSchema, language) {

    const arrayOfTournamentsToSave = [];

    await Promise.all(tournaments.map(async (tournament) => {

            // console.log('elaborating tournament id: ', tournament.tournamentId)

            tournament.status_rule = true;

            if (rulesSchema.tournamentManager) {
                tournament = await rulesHandler.applyRules(tournament, rules.manager, tournament.tournamentId)
            }

            if (rulesSchema.tournamentSkin) {
                tournament = await rulesHandler.applyRules(tournament, rules.skin, tournament.tournamentId)
            }

            if (!tournament.status_rule) {
                //console.log('EXCLUDING TOURNAMENT WITH ID: ' + tournament.tournamentId)
                return
            }

            await rulesHandler.applyTranslationToElement(tournament, language)

            arrayOfTournamentsToSave.push(tournament);
        }
    ))

    const tournaments_pm_ordered = orderBy(arrayOfTournamentsToSave, ['order', 'name'])
    return tournaments_pm_ordered;
}

async function refactorTournamentsAntepost(tournaments, rules, rulesSchema, language) {

    const arrayOfTournamentsToSave = [];

    await Promise.all(tournaments.map(async (tournament) => {

            tournament.status_rule = true;

            if (rulesSchema.tournamentManager) {
                tournament = await rulesHandler.applyRules(tournament, rules.manager, tournament.tournamentId)
            }

            if (rulesSchema.tournamentSkin) {
                tournament = await rulesHandler.applyRules(tournament, rules.skin, tournament.tournamentId)
            }

            if (!tournament.status_rule) {
                //console.log('EXCLUDING TOURNAMENT WITH ID: ' + tournament.tournamentId)
                return
            }

            arrayOfTournamentsToSave.push(tournament);

            await refactorEventsAntepost(tournament.children, rules, rulesSchema);
        }
    ))

    const tournaments_pm_ordered = orderBy(arrayOfTournamentsToSave, ['order', 'name'])
    return tournaments_pm_ordered
}


async function refactorEventsAntepost(events, rules, rulesSchema) {

    const arrayOfEventsToSave = [];

    await Promise.all(events.map(async (event) => {

            let status = true;

            if (rulesSchema.eventManager || rulesSchema.eventSkin) {

                const rule_manager = await find(rules.manager, (rule) => {
                    return rule.type == "disable" && rule.scope == "event" && rule.source == event.id
                });


                const rule_skin = await find(rules.skin, (rule) => {
                    return rule.type == "disable" && rule.scope == "event" && rule.source == event.id
                });

                if (rule_manager != undefined) {
                    let rule = await find(rule_manager.detail, {'scope': 'event'})
                    if (rule) {

                        status = !rule.status
                    }
                }

                if (rule_skin != undefined) {
                    let rule = await find(rule_skin.detail, {'scope': 'event'})
                    if (rule) {
                        status = !rule.status
                    }
                }

            }

            if (status) {

                if (event.raceTitle && event.raceNumber) {
                    if (event.raceTitle.includes(event.raceNumber)) {
                        event.name = event.name + ' - ' + event.raceTitle;
                    } else {
                        event.name = event.name + ' - ' + event.raceTitle + ' - n° ' + event.raceNumber
                    }
                }
                //await rulesHandler.applyTranslationToElement(event, language)
                arrayOfEventsToSave.push(event)
            }
        }
    ))

    const events_pm_ordered = orderBy(arrayOfEventsToSave, ['name'])

    return events_pm_ordered
}

export default {
    refactorTree,
    getAntepostDetails,
    refactorSports,
    refactorCategories,
    refactorTournaments,
    refactorTournamentsAntepost,
    refactorEventsAntepost
}